import { visualAssets } from './visualAssets';

export interface AssetDefinition {
  id: string;
  type: 'image' | 'audio';
  path: string;
  critical: boolean;
  placeholder: boolean;
}

export const assetManifest = {
  raadhustorvetBackground: {
    id: 'raadhustorvet-background',
    type: 'image',
    path: 'assets/locations/raadhustorvet/background.svg',
    critical: true,
    placeholder: true,
  },
  grainSackIcon: {
    id: 'grain-sack-icon',
    type: 'image',
    path: 'assets/locations/raadhustorvet/grain-sack.svg',
    critical: false,
    placeholder: true,
  },
  mapBackground: {
    id: 'map-background',
    type: 'image',
    path: visualAssets.map,
    critical: true,
    placeholder: false,
  },
  soldaterboegenBackground: {
    id: 'soldaterboegen-background',
    type: 'image',
    path: 'assets/locations/soldaterboegen/background-placeholder.png',
    critical: true,
    placeholder: true,
  },
  knifeIcon: {
    id: 'knife-icon',
    type: 'image',
    path: 'assets/locations/soldaterboegen/knife-placeholder.png',
    critical: false,
    placeholder: true,
  },
} satisfies Record<string, AssetDefinition>;

export const futureAudioAssets = {
  mapMusic: 'assets/music/map-theme.mp3',
  soldaterboegenMusic: 'assets/locations/soldaterboegen/music.mp3',
  soldaterboegenAmbience: 'assets/locations/soldaterboegen/ambience.mp3',
} as const;
